import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getMaintenanceStatusList as getMaintenanceStatusListApi,
	getMaintenanceStatus as getMaintenanceStatusApi,
	getMaintenanceStatusCode as getMaintenanceStatusCodeApi,
	addNewMaintenanceStatus as addNewMaintenanceStatusApi,
	updateMaintenanceStatus as updateMaintenanceStatusApi,
	deleteMaintenanceStatus as deleteMaintenanceStatusApi,
} from '../../helpers/establishment/backend_helper';

export const getMaintenanceStatusList = createAsyncThunk('maintenanceStatus/getMaintenanceStatusList', async () => {
	try {
		const response = getMaintenanceStatusListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getMaintenanceStatus = createAsyncThunk('maintenanceStatus/getMaintenanceStatus', async maintenanceStatus_id => {
	try {
		const response = getMaintenanceStatusApi(maintenanceStatus_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getMaintenanceStatusCode = createAsyncThunk('maintenanceStatus/getMaintenanceStatusCode', async code => {
	try {
		const response = getMaintenanceStatusCodeApi(code);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewMaintenanceStatus = createAsyncThunk('maintenanceStatus/addNewMaintenanceStatus', async maintenanceStatus => {
	try {
		const response = addNewMaintenanceStatusApi(maintenanceStatus);
		toast.success('Estado de Mantención agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar maintenanceStatus.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateMaintenanceStatus = createAsyncThunk('maintenanceStatus/updateMaintenanceStatus', async (maintenanceStatus) => {
		try {
			const response = updateMaintenanceStatusApi(maintenanceStatus);
			toast.success('Estado de Mantención actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar maintenanceStatus.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteMaintenanceStatus = createAsyncThunk('maintenanceStatus/deleteMaintenanceStatus', async maintenanceStatus => {
	try {
		const response = await deleteMaintenanceStatusApi(maintenanceStatus);
		toast.success('Estado de Mantención eliminado exitosamente.', { autoClose: 3000 });
		return { maintenanceStatus, ...response };
	} catch (error) {
		toast.error('Error al eliminar maintenanceStatus.', { autoClose: 3000 });
		throw new Error(error);
	}
});


